import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { ProfileService } from 'src/app/services/profile.service';
import { AdminService } from 'src/app/services/admin.service';
import { AlertController, IonInput, IonModal, LoadingController, NavController } from '@ionic/angular';
import { ToastService } from 'src/app/services/toast.service';
import avatarsData from 'src/assets/images/avatars.json'
import { OverlayEventDetail } from '@ionic/core/components';
import { AuthService } from 'src/app/services/auth.service';
import { UserCreditsData } from 'src/app/classes/UserProfile';
import { SongDraftService } from 'src/app/services/song-draft.service';
import { Browser } from '@capacitor/browser';
import { LEGAL_URLS } from 'src/app/config/legal';
import { App } from '@capacitor/app';
import { BuildInfo, getBuildInfo } from 'src/app/build-info';

type ProfileLink = {
  id: string;
  title: string;
  subtitle: string;
  icon: string;
  link: string;
};


@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {
  @ViewChild(IonModal) modal!: IonModal;
  /** Stand der ausgelieferten App - siehe build-info.ts. */
  buildInfo: BuildInfo = getBuildInfo();
  /** Nur nativ verfuegbar; im Browser bleibt das Feld leer. */
  appVersion = '';
  profileService = inject(ProfileService);
  adminService = inject(AdminService);
  authService = inject(AuthService);
  songDraftService = inject(SongDraftService);
  guestAcc: boolean = false;
  inputUserName: string = "";
  inputMail: string = "";
  inputPassword: string = "";
  avatars: string[] = avatarsData;
  selectedAvatar!: string;
  public showPassword = false;

  accountLinks: ProfileLink[] = [
    // { id: 'songs', title: 'Meine Lieder', subtitle: 'Alle generierten Songs ansehen', icon: 'musical-note-outline', link: 'song-list' },
    { id: 'profile-edit', title: 'Profil bearbeiten', subtitle: 'Profilname, Mail, Passwort', icon: 'person-outline', link: 'profile-edit' },
    // { id: 'settings', title: 'Einstellungen', subtitle: 'Passwort, Benachrichtigungen', icon: 'settings-outline', link: '' },
  ];

  supportLinks: ProfileLink[] = [
    { id: 'support', title: 'Hilfe & Support', subtitle: 'Kontakt, Rechtliches', icon: 'help-circle-outline', link: 'https://melowish.com/kontakt/' },
    { id: 'logout', title: 'Logout', subtitle: '', icon: 'exit-outline', link: 'logout' },
  ];

  @ViewChild('pwInput') pwInput!: IonInput;

  constructor(
    private alertController: AlertController,
    private navCtr: NavController,
    private loadingCtrl: LoadingController
  ) {}



  ngOnInit() {
    if(this.profileService.userProfile) {
      this.guestAcc = this.profileService.userProfile.isGuest();
      this.inputUserName = this.profileService.userProfile.displayName;
      this.inputMail = this.profileService.userProfile.email ?? "";
      this.selectedAvatar = this.profileService.userProfile.photoURL ?? "";
      console.log("slecelted",this.selectedAvatar)
    }

    // Nur nativ vorhanden - im Browser wirft der Aufruf. Bewusst nicht
    // erwartet und bewusst abgefangen: die Build-Kennung darunter steht
    // ohnehin, sie kommt aus dem Bundle.
    void App.getInfo()
      .then((info) => { this.appVersion = info.version; })
      .catch(() => { /* Browser */ });
  }

  async logoutUserPrompt() {
    const alert = await this.alertController.create({
      cssClass: "text-align-left",
      header: "Logout",
      message: "Möchstest du dich wirklich abmelden?",
      buttons: [
        {
          text: "Abbrechen",
          role: "cancel",
          cssClass: "secondary"
        },
        {
          text: "Abmelden",
          handler: async (data: any) => {
            this.logoutUser();
          },
        },
      ],
    });

    alert.present();
  }
  async logoutUser() {
    if(this.songDraftService.hasDraft()) {
      this.songDraftService.clearDraft();
    }
    await this.authService.logoutUser();
    this.navCtr.navigateRoot(["home"]);
  }

  async convertAnonAcc() {
    const loading = await this.loadingCtrl.create({
      message: 'Verifiziere Benutzeraccount...',
    });
    await loading.present();
    let errorCode = "";

    if(this.inputUserName && this.inputMail && this.inputPassword) {
      if (!this.isValidName(this.inputUserName)) {
        loading.dismiss();
        return;
      }
      errorCode = await this.profileService.convertAnonUser(this.inputUserName,this.inputMail,this.inputPassword)
    } else {
      loading.dismiss();
      ToastService.makeToast("Du musst zuerst alle Felder ausfüllen.")
      return;
    }

    loading.dismiss();
    if(!errorCode) {
      ToastService.makeToast("Dein Benutzer wurde erfolgreich verifiziert.")
      this.guestAcc = this.profileService.userProfile?.isGuest() || false;
    } else {
      if(errorCode == "auth/weak-password") {
        ToastService.makeToast("Das Passwort muss mindestens 6 Zeichen lang sein.")
      } else if(errorCode == "auth/email-already-in-use") {
        ToastService.makeToast("Die Email-Adresse wird bereits verwendet.")
      } else if(errorCode == "auth/invalid-email") {
        ToastService.makeToast("Die Email-Adresse ist ungültig.")
      } else {
        console.error("ConvertAnonAcc - Error:",errorCode)
        ToastService.makeToast("Fehler bei der Verifizierung. Probiere es später noch einmal.")
      }
      this.inputMail = "";
      this.inputPassword = "";
    }
  }

  async saveProfileData() {
    const loading = await this.loadingCtrl.create({
      message: 'Speichere Benutzerdaten...',
    });
    await loading.present();

    if(this.inputUserName) {
      if (!this.isValidName(this.inputUserName)) {
        loading.dismiss();
        return;
      }
      this.profileService.userProfile?.setDisplayName(this.inputUserName);
      await this.profileService.saveProfile();
    } else {
      loading.dismiss();
      ToastService.makeToast("Du musst zuerst alle Felder ausfüllen.")
      return;
    }

    loading.dismiss();
  }

  isValidName(n: string): boolean {
    let pattern = /^[a-zA-ZäöüßÄÖÜôÔâÂêéèÉÈÊîíìúùûý0-9 ]{1,15}$/;
    if (n.trim() === "") {
      ToastService.makeToast("Der Benutzername darf nicht leer sein.");
      return false;
    }

    if (n.length > 15) {
      ToastService.makeToast("Der Benutzername darf maximal 15 Zeichen lang sein.");
      return false;
    }

    if (!pattern.test(n)) {
      ToastService.makeToast("Der Benutzername darf nur Buchstaben, Zahlen und Leerzeichen enthalten.");
      return false;
    }

    return pattern.test(n.trim());
  }

  togglePwShow() {
    this.showPassword = !this.showPassword;
    this.pwInput.type =  this.showPassword ? 'text' : 'password';
  }

  profPicModalCancel() {
    this.modal.dismiss(null, 'cancel');
  }

  profPicModalConfirm() {
    this.modal.dismiss(this.selectedAvatar, 'confirm');
  }

  profPicModalOnWillDismiss(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    if (ev.detail.role === 'confirm') {
      if(ev.detail.data) {
        this.profileService.userProfile?.setPhotoURL(ev.detail.data);
        this.profileService.saveProfile();
        console.log("Avatar set: ", ev.detail.data);
      }
    }
  }

  avatarSelected(avatarName: string) {
    this.selectedAvatar = avatarName;
  }

  openModal() {
    if(this.guestAcc) {
      ToastService.makeToast("Du kannst ohne Verifizierung dein Profilbild nicht ändern.");
    } else {
      this.modal.present();
    }
  }


getAvailableSongCount(credits: UserCreditsData) {
  let availableCredits: string[] = [];
  if(credits.songBasic > 0) {
    availableCredits.push(`${credits.songBasic} Basic`);
  }
  if(credits.songPremium > 0) {
    availableCredits.push(`${credits.songPremium} Premium`);
  }
  if(credits.songExclusive > 0) {
    availableCredits.push(`${credits.songExclusive} Exclusive`);
  }
  return availableCredits.length > 0 ? availableCredits.join(", ") : '–'
}

  navProfileEdit() {
    this.navCtr.navigateForward("profile-edit");
  }

  topUpCredits() {
    this.navCtr.navigateForward("/song-plans")
    console.log('top up');
  }

  async openLink(link: string) {
    if(link == "logout") {
      this.logoutUserPrompt();
    } else if(link.startsWith("https://")) {
      // window.open(link, "_blank");
      await Browser.open({ url: link })
    } else {
      this.navCtr.navigateForward(link);
    }
    // npm install @capacitor-community/inappbrowser
    // npx cap sync

    // Code:

    // import { InAppBrowser } from '@capacitor-community/inappbrowser';

    // await InAppBrowser.openInWebView({
    //   url: link
    // });
  }

  /**
   * Rechtstexte liegen auf der Marketing-Seite, nicht in der App.
   *
   * Eine zweite Fassung in der App waere eine zweite Wahrheit - und die, die
   * niemand pflegt. Bis zum 30.09.2026 stand hier nur ein console.log: die
   * Links waren da, fuehrten aber nirgendwohin.
   */
  openLegal(which: 'impressum' | 'datenschutz' | 'agb') {
    const url = LEGAL_URLS[which];
    if (!url) return;
    void Browser.open({ url });
  }

  trackById(_: number, item: ProfileLink) {
    return item.id;
  }

}
